import { keys as localStorageKeys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';

import type { ShareContentType } from '../share-criteria-types.ts';

import { addTriggeredType, hasTypeTriggeredBefore } from './triggeredTypesState.ts';

const TRIGGERED_TYPES_KEY = localStorageKeys.FLAG_TO_SHARE_CRITERIA_MET_TRIGGERED_TYPES;

/**
 * Whether `type` has already had its "criteria met" Post Office trigger
 * fired at least once before for this user, on this device/browser. Reads
 * are synchronous (plain local storage) so this can be called directly
 * during render.
 */
export function hasContentTypeTriggeredBefore(type: ShareContentType): boolean {
	const rawValue: string | null = localStorage.getItem(TRIGGERED_TYPES_KEY);
	return hasTypeTriggeredBefore(rawValue, type);
}

/**
 * Persists that `type` has now fired the "criteria met" trigger at least
 * once, merging it into the existing delimited list of triggered types.
 */
export function markContentTypeTriggered(type: ShareContentType): void {
	const rawValue: string | null = localStorage.getItem(TRIGGERED_TYPES_KEY);
	localStorage.setItem(TRIGGERED_TYPES_KEY, addTriggeredType(rawValue, type));
}
